import { nanoid } from 'nanoid';

/** @type {import('@knitiv/api-client-javascript').QueryExecJSONInput['query']} */
const query = {
	select: [
		{
			inherits_extended: -1,
			kid: 'K_NODE;KSYSQUERY',
			id: nanoid(),
			name: 'Knitiv Requete',
			node: 'REPRE',
			op: 'detail',
			type: 'K_NODE;STRING',
			width: 180,
		},
	],
	from: [
		{
			inherits_extended: -1,
			name: 'Knitiv Requete',
			node: 'K_NODE;KSYSQUERY',
			type: 'K_NODE;STRING',
		},
	],
	where: {
		condition: 'AND',
		rules: [
			{
				condition: 'AND',
				field: 'K_NODE;BOOL',
				having: null,
				id: 'K_NODE;BOOL',
				label: 'Booléen :: Visible',
				operator: 'equal_kid',
				path: [
					{
						kid: 'K_NODE;KSYSQUERY',
						name: 'Knitiv Requete',
						linker_kid: '0',
					},
					{
						kid: 'K_NODE;BOOL',
						name: 'Booléen',
						flow: 'down',
						linker_kid: 'K_NODE;VISIBLE',
						linker_info: {
							kid: 'K_NODE;VISIBLE',
							name: 'Visible',
						},
					},
				],
				type: 'K_NODE;STRING',
				value: [
					{
						kid: 'K_NODE;TRUE',
						isa: 'K_NODE;BOOL',
						isa_name: 'Booléen',
						name: 'Vrai',
					},
				],
				linker_kid: 'K_NODE;VISIBLE',
			},
		],
	},
	date: '_NOW_',
};

export default query;
